'use strict';

export function createMyDownloadsGrid({
    gridSelector,
    pagerSelector,
    dateDisplayFormat,
} = {}) {

    const $grid = $(gridSelector);
    const feedURL = '/components/invoice.cfc?method=getMyInvoiceZipJobsWeb&jobType=zip';
    const downloadURL = '/components/invoice.cfc?method=getInvoiceZipDownloadWeb';
    const gridDateFormat = (dateDisplayFormat || '') + ' H:i';

    function getGridBaseURL() {
        return feedURL;
    }

    function reload() {
        $grid.jqGrid('setGridParam', { url: getGridBaseURL(), page: 1 }).trigger('reloadGrid');
    }

    // Renders the description text with a New badge for not-yet-downloaded Ready jobs
    function descriptionFormatter(cellValue, options, rowObject) {
        // rowObject: [ID, File, Reference, Invoices, Requested, Completed, Status, Ready, IsNew, Download, JobType, JobUUID, InvoiceType]
        let label = escapeHtml(cellValue || 'Invoice ZIP');
        if (rowObject[12] === 'nomination') {
            label += ' ' + NOMINATION_TAG;
        }
        if (String(rowObject[8]) === '1') {
            label += ' <span class="js-new-badge new-badge td-new">New' +
                '<span class="td-new__dismiss js-dismiss-zip-new" role="button" tabindex="0"' +
                    ' title="Mark as seen" aria-label="Mark as seen">&times;</span>' +
                '</span>';
        }
        return label;
    }

    function dismissNew($dismiss) {
        const rowid = $dismiss.closest('tr.jqgrow').attr('id');
        const jobID = $grid.jqGrid('getCell', rowid, 'ID');
        $dismiss.closest('.td-new').remove();

        $.ajax({
            url: '/components/invoice.cfc?method=markInvoiceZipSeenWeb',
            type: 'POST',
            dataType: 'json',
            data: { jobID: jobID },
        }).done(() => {
            reload();
            refreshMyDownloadsBadge();
        });
    }

    // onCellSelect only sees clicks, so Enter/Space on the dismiss control is handled here
    $grid.delegate('.js-dismiss-zip-new', 'keydown', function (event) {
        if (event.which !== 13 && event.which !== 32) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        dismissNew($(this));
    });

    // Renders a Download button for Ready jobs, otherwise the status text
    function downloadFormatter(cellValue, options, rowObject) {
        // rowObject: [ID, File, Reference, Invoices, Requested, Completed, Status, Ready, IsNew, Download, JobType, JobUUID]
        const status = rowObject[6];
        const ready = String(rowObject[7]) === '1';

        if (ready) {
            return '<span class="js-download-zip prettyLink">Download</span>';
        }
        if (status === 'Failed') {
            return '<span class="ui-state-error-text">Failed</span>';
        }
        return 'Pending';
    }

    EQLAPP.COMMON.register({
        'gridID': $grid.attr('id'),
    });

    $grid.jqGrid({
        url: getGridBaseURL()
        ,datatype: 'json'
        ,colNames: [
            'ID', 'Description', 'Reference', 'Invoices', 'Requested',
            'Completed', 'Status', 'Ready', 'IsNew', 'Download', 'JobType', 'JobUUID', 'InvoiceType']
        ,colModel: [
            { index: 'ID', name: 'ID', width: 0, hidden: true }
            // eslint-disable-next-line max-len
            ,{ index: 'File', name: 'File', width: 140, sortable: false, formatter: descriptionFormatter }
            ,{ index: 'Reference', name: 'Reference', width: 90, sortable: false, align: 'center' }
            ,{ index: 'Invoices', name: 'Invoices', width: 50, sortable: false, align: 'center' }
            ,{
                name: 'Requested',
                index: 'Requested',
                width: 90,
                sortable: false,
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: gridDateFormat,
                },
                align: 'center',
            }
            ,{
                name: 'Completed',
                index: 'Completed',
                width: 90,
                sortable: false,
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: gridDateFormat,
                },
                align: 'center',
            }
            ,{ index: 'Status', name: 'Status', width: 0, sortable: false, hidden: true }
            ,{ index: 'Ready', name: 'Ready', width: 0, hidden: true }
            ,{ index: 'IsNew', name: 'IsNew', width: 0, hidden: true }
            ,{
                index: 'Download', name: 'Download', width: 90, sortable: false,
                align: 'center', classes: 'pointer', formatter: downloadFormatter,
            }
            ,{ index: 'JobType', name: 'JobType', width: 0, hidden: true }
            ,{ index: 'JobUUID', name: 'JobUUID', width: 0, hidden: true }
            ,{ index: 'InvoiceType', name: 'InvoiceType', width: 0, hidden: true },
        ]
        ,rowNum: 10
        ,rowList: [10, 20, 30]
        ,autowidth: true
        ,height: '100%'
        ,pager: pagerSelector
        ,sortname: 'CreatedAt'
        ,sortorder: 'desc'
        ,loadComplete: function () {
            if (typeof gridFix === 'function') {
                gridFix(gridSelector);
            }
        }
        ,onCellSelect: function (rowid, iCol, cellcontent, e) {
            const $cell = $(e.target);
            if ($cell.hasClass('js-dismiss-zip-new')) {
                dismissNew($cell);
                return;
            }
            if (!$cell.hasClass('js-download-zip')) { return; }

            const jobID = $grid.jqGrid('getCell', rowid, 'ID');

            $.ajax({
                url: downloadURL,
                type: 'GET',
                dataType: 'json',
                data: { jobID: jobID }
            })
                .done((result) => {
                    if (result && result.SUCCESS && result.SASURL) {
                        window.location.assign(result.SASURL);
                        reload();
                    } else {
                        // eslint-disable-next-line max-len
                        alert((result && result.MESSAGE) ? result.MESSAGE : 'Unable to download at this time. Please try again.');
                    }
                })
                .fail(() => {
                    alert('Unable to download at this time. Please try again.');
                });
        },
    });

    return { grid: $grid, reload: reload };
}

function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

const NOMINATION_TAG = '<span class="ir-tag ir-tag--nomination">Nomination</span>';

// Shared by the Tasks & Downloads cards and the Email Invoices "Recent Invoice Reviews" list
export function getReviewStatus(review) {
    if (review.status === 'Failed') {
        return { key: 'failed', label: 'Failed' };
    }
    if (review.status !== 'Ready') {
        return { key: 'preparing', label: 'Preparing' };
    }
    if (review.sendState === 'all') {
        return { key: 'emailed', label: 'Emailed All' };
    }
    if (review.sendState === 'partial') {
        return { key: 'emailed', label: 'Emailed (' + review.emailed + ' of ' + review.invoiceCount + ')' };
    }
    return { key: 'todo', label: 'Not emailed' };
}

const REVIEW_KEYS = [
    'jobUUID', 'status', 'isNew', 'createdDisplay', 'invoiceStart', 'invoiceEnd',
    'invoiceCount', 'missingEmail', 'emailed', 'sendState', 'reviewURL', 'invoiceType',
];

// ColdFusion may upper-case struct keys in JSON, so map them back to the expected camelCase names
function pickKey(obj, name) {
    const wanted = name.toLowerCase();
    let found;
    $.each(obj || {}, (key, value) => {
        if (String(key).toLowerCase() === wanted) {
            found = value;
            return false;
        }
        return true;
    });
    return found;
}

function toBool(value) {
    return value === true || value === 1 || /^(true|yes|1)$/i.test(String(value));
}

function normaliseReview(raw) {
    const review = {};
    REVIEW_KEYS.forEach((key) => {
        review[key] = pickKey(raw, key);
    });
    review.isNew = toBool(review.isNew);
    review.invoiceCount = parseInt(review.invoiceCount, 10) || 0;
    review.missingEmail = parseInt(review.missingEmail, 10) || 0;
    review.emailed = parseInt(review.emailed, 10) || 0;
    review.invoiceStart = review.invoiceStart === undefined || review.invoiceStart === null ? '' : String(review.invoiceStart);
    review.invoiceEnd = review.invoiceEnd === undefined || review.invoiceEnd === null ? '' : String(review.invoiceEnd);
    return review;
}

// Resolves with { success, reviews, total, page, pageSize } where reviews use camelCase keys
export function fetchReviewJobs({ limit = 10, page = 1 } = {}) {
    const deferred = $.Deferred();
    $.ajax({
        url: '/components/invoice.cfc?method=getMyInvoiceReviewJobsWeb',
        type: 'GET',
        dataType: 'json',
        cache: false,
        data: { limit: limit, page: page },
    }).done((result) => {
        const reviews = pickKey(result, 'reviews');
        deferred.resolve({
            success: toBool(pickKey(result, 'success')),
            reviews: $.isArray(reviews) ? $.map(reviews, normaliseReview) : [],
            total: parseInt(pickKey(result, 'total'), 10) || 0,
            page: parseInt(pickKey(result, 'page'), 10) || 1,
            pageSize: parseInt(pickKey(result, 'pageSize'), 10) || limit,
        });
    }).fail(() => {
        deferred.reject();
    });
    return deferred.promise();
}

export const INVOICE_ICON = '<svg class="td-card__icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">' +
    '<path d="M3.5 1.5h6l3 3v10h-9z" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
    '<path d="M9.5 1.5v3h3M5.5 7.5h5M5.5 9.75h5M5.5 12h3" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
    '</svg>';

export function markReviewSeen(jobUUID) {
    return $.ajax({
        url: '/components/invoice.cfc?method=markInvoiceReviewViewedWeb',
        type: 'POST',
        dataType: 'json',
        data: { batchID: jobUUID },
    });
}

export function createMyReviewGrid({
    gridSelector,
    pagerSelector,
    dateDisplayFormat,
} = {}) {

    const $grid = $(gridSelector);
    const feedURL = '/components/invoice.cfc?method=getMyInvoiceReviewGridWeb';
    const gridDateFormat = (dateDisplayFormat || '') + ' H:i';

    function reload() {
        $grid.jqGrid('setGridParam', { url: feedURL, page: 1 }).trigger('reloadGrid');
    }

    // Description plus the email-status pill, and a New badge until the review is opened
    function descriptionFormatter(cellValue, options, rowObject) {
        // rowObject: [JobUUID, Description, Type, Invoices, Requested, Completed, View,
        //             Status, Ready, IsNew, SendState, Emailed, ReviewURL]
        let label = escapeHtml(cellValue || '');
        if (rowObject[7] === 'Ready') {
            const state = getReviewStatus({
                status: rowObject[7],
                sendState: rowObject[10],
                emailed: parseInt(rowObject[11], 10) || 0,
                invoiceCount: parseInt(rowObject[3], 10) || 0,
            });
            label += ' <span class="td-status td-status--' + state.key + '">' +
                escapeHtml(state.label) + '</span>';
        }
        if (String(rowObject[9]) === '1') {
            label += ' <span class="js-new-badge new-badge td-new">New' +
                '<span class="td-new__dismiss js-dismiss-review-new" role="button" tabindex="0"' +
                    ' title="Mark as seen" aria-label="Mark as seen">&times;</span>' +
                '</span>';
        }
        return label;
    }

    function dismissNew($dismiss) {
        const rowid = $dismiss.closest('tr.jqgrow').attr('id');
        const jobUUID = $grid.jqGrid('getCell', rowid, 'JobUUID');
        $dismiss.closest('.td-new').remove();

        markReviewSeen(jobUUID).done(() => {
            reload();
            refreshMyDownloadsBadge();
        });
    }

    $grid.delegate('.js-dismiss-review-new', 'keydown', function (event) {
        if (event.which !== 13 && event.which !== 32) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        dismissNew($(this));
    });

    // A link once the review can be opened; otherwise the same pending/failed text as downloads
    function viewFormatter(cellValue, options, rowObject) {
        const status = rowObject[7];
        const ready = String(rowObject[8]) === '1';

        if (ready) {
            return '<a class="prettyLink" href="' + escapeHtml(rowObject[12] || '') + '">View</a>';
        }
        if (status === 'Failed') {
            return '<span class="ui-state-error-text">Failed</span>';
        }
        return 'Pending';
    }

    EQLAPP.COMMON.register({
        'gridID': $grid.attr('id'),
    });

    $grid.jqGrid({
        url: feedURL
        ,datatype: 'json'
        ,colNames: [
            'JobUUID', 'Description', 'Type', 'Invoices', 'Requested', 'Completed', 'View',
            'Status', 'Ready', 'IsNew', 'SendState', 'Emailed', 'ReviewURL']
        ,colModel: [
            { index: 'JobUUID', name: 'JobUUID', width: 0, hidden: true }
            ,{
                index: 'Description',
                name: 'Description',
                width: 280,
                sortable: false,
                formatter: descriptionFormatter,
            }
            ,{ index: 'Type', name: 'Type', width: 80, sortable: false, align: 'left' }
            ,{ index: 'Invoices', name: 'Invoices', width: 50, sortable: false, align: 'center' }
            ,{
                name: 'Requested',
                index: 'Requested',
                width: 90,
                sortable: false,
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: gridDateFormat,
                },
                align: 'center',
            }
            ,{
                name: 'Completed',
                index: 'Completed',
                width: 90,
                sortable: false,
                formatter: 'date',
                formatoptions: {
                    srcformat: 'ISO8601Long',
                    newformat: gridDateFormat,
                },
                align: 'center',
            }
            ,{
                index: 'View', name: 'View', width: 90, sortable: false,
                align: 'center', formatter: viewFormatter,
            }
            ,{ index: 'Status', name: 'Status', width: 0, sortable: false, hidden: true }
            ,{ index: 'Ready', name: 'Ready', width: 0, hidden: true }
            ,{ index: 'IsNew', name: 'IsNew', width: 0, hidden: true }
            ,{ index: 'SendState', name: 'SendState', width: 0, hidden: true }
            ,{ index: 'Emailed', name: 'Emailed', width: 0, hidden: true }
            ,{ index: 'ReviewURL', name: 'ReviewURL', width: 0, hidden: true },
        ]
        ,rowNum: 5
        ,rowList: [5, 10, 15]
        ,autowidth: true
        ,height: '100%'
        ,pager: pagerSelector
        ,sortname: 'CreatedAt'
        ,sortorder: 'desc'
        ,loadComplete: function () {
            if (typeof gridFix === 'function') {
                gridFix(gridSelector);
            }
        }
        ,onCellSelect: function (rowid, iCol, cellcontent, e) {
            const $cell = $(e.target);
            if ($cell.hasClass('js-dismiss-review-new')) {
                dismissNew($cell);
            }
        },
    });

    return { grid: $grid, reload: reload };
}

export function refreshMyDownloadsBadge() {
    return $.ajax({
        url: '/components/invoice.cfc?method=getReadyInvoiceZipCountWeb',
        type: 'GET',
        dataType: 'json',
    }).done((result) => {
        const $container = $('#menu_settings')
            .find('a.menu_download_folder')
            .closest('.navToolTip');
        const $tooltip = $container.find('.tooltiptext');
        const parts = [];

        if (result && result.SUCCESS && result.COUNT > 0) {
            $container.attr('data-badge', result.COUNT);
            if (result.REVIEWCOUNT > 0) {
                parts.push(result.REVIEWCOUNT + ' to review');
            }
            if (result.DOWNLOADCOUNT > 0) {
                parts.push(result.DOWNLOADCOUNT + (result.DOWNLOADCOUNT === 1 ? ' download' : ' downloads'));
            }
        } else {
            $container.removeAttr('data-badge');
        }

        $tooltip.text('Tasks & Downloads' + (parts.length ? ' (' + parts.join(', ') + ')' : ''));
    });
}

export function initMyDownloadsBadge({ intervalMs = 30000 } = {}) {
    if (!window.jQuery) { return; }
    $(document).ready(() => {
        refreshMyDownloadsBadge();
        if (intervalMs > 0) {
            setInterval(refreshMyDownloadsBadge, intervalMs);
        }
    });
}
